import store from "./store";

export * from "./companySlice";
export * from "./currentUserSlice";
export * from "./documentsSlice";
export * from "./hintsSlice";
export * from "./notificationsSlice";
export * from "./projectsSlice";
export * from "./tasksSlice";
export * from "./talentPoolSlice";
export * from "./uiSlice";
export * from "./whitepaperSlice";

export default store;
